<script setup>
import { pageTransition } from '~/helpers/animations/animations';
definePageMeta({
  pageTransition: pageTransition,
});

const { locale, t } = useI18n();
const route = useRoute();
const breadcrumbs = ref([{ title: t('pages.events.breadcrumbs-title') }]);

const pageQuery = gql`
  query getPageData {
    buildings(filterVisibleInFilters: true) {
      id
      name
      seo_url_slug {
        cs
        en
      }
    }
    tags(filterVisibleInFilters: true) {
      id
      name
      description
      slug {
        cs
        en
      }
    }
    eventCategories {
      id
      name
      slug {
        cs
        en
      }
    }
  }
`;

const { data } = await useAsyncQuery(pageQuery);

const buildings = ref(data.value?.buildings);
const tags = ref(data.value?.tags);
const eventCategories = ref(data.value?.eventCategories);

useHeadData({
  title: t('pages.events.head.title'),
  description: t('pages.events.head.description'),
  keywords: t('pages.events.head.keywords'),
  url: route.fullPath,
});
</script>

<template>
  <main class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <ClientOnly v-if="buildings && tags && eventCategories">
      <Events :buildings="buildings" :tags="tags" :event-categories="eventCategories" />
    </ClientOnly>
  </main>
</template>
